<script>
	
import Header from './components/Header.svelte'; 
import Main from './components/Main.svelte';
import About from './components/About.svelte';
import Stats from './components/Stats.svelte';
import Footer from './components/Footer.svelte';

let route = location.pathname;

function handleRouteMessage(event) {
  const newRoute = event.detail.route;
  history.pushState(null, null, newRoute);
  route = newRoute;
}
  
</script>


<main>

  <Header/>
  
  {#if route === '/about' || route === '/about/'}
    <About/>
  {:else if route === '/stats' || route === '/stats/'}
    <Stats/>
  {:else}
    <Main/>
  {/if} 
  
  <Footer on:message={handleRouteMessage}/>

</main>


<style>

main {
  padding:15px;
  max-width:40rem;
  margin:0 auto;
}

</style>
